import { useState } from "react";
import { Button, Col, Modal, Row, Form } from "react-bootstrap";
import { useAppSelector } from "redux/hooks";
import { RootState } from "redux/store";
import { FormInput } from "components";

type bulkEditProps = {
    show: boolean;
    handleClose: () => void;
};

export function BulkEdit(props: bulkEditProps) {
    const priceGroup = useAppSelector((state: RootState) => state.priceGroups);
    const [copyBasePrice, setCopyBasePrice] = useState(false);
    const [changeSellPriceByAmount, setChangeSellPriceByAmount] = useState(0);
    const [changeSellPriceByPercentage, setChangeSellPriceByPercentage] = useState(0);
    const [changeCurrentGPby, setChangeCurrentGPby] = useState(0);
    const [changeSellPriceBy, setChangeSellPriceBy] = useState(1);

    function saveSelectedStock() {
        let selectedStocks: any = [];
        priceGroup.selectedRows.map((item: any) => item.forEach((stock: any) => {
            selectedStocks.push(stock);
        }));
        props.handleClose();
    }

    return (
        <Modal size="lg" centered show={props.show} onHide={props.handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Bulk Edit - {priceGroup.selectedRows.length} Stocks Selected</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row className="mt-3 mb-3 pe-0">
                    <Row className="ms-0">
                        <Col xs={5}>
                            <p className="popup-form-text-field">Copy Base Sell Price</p>
                        </Col>
                        <Col xs={5}>
                            <FormInput
                                min={1}
                                required
                                type="checkbox"
                                name="price-level-cost"
                                containerClass={"mb-2"}
                                checked={copyBasePrice}
                                onChange={(e) => setCopyBasePrice(e.target.checked)}
                            />
                        </Col>
                    </Row>
                    <Row className="ms-0">
                        <Col xs={5}>
                            <p className="popup-form-text-field">Change Sell Price By</p>
                        </Col>
                        <Col xs={5}>
                            <Form.Group>
                                <Form.Select
                                    className="custom-select mb-2"
                                    style={{ fontSize: "13px" }}
                                    value={changeSellPriceBy}
                                    onChange={(e) => setChangeSellPriceBy(parseInt(e.target.value))}
                                >
                                    <option value={1}>% Percentage </option>
                                    <option value={2}>Add $ Amount</option>
                                    <option value={3}>Set to a $ Fix Amount</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </Row>
                    {changeSellPriceBy === 1 && <>
                        <Row className="ms-0">
                            <Col xs={5}>
                                <p className="popup-form-text-field">Change Sell Price By %</p>
                            </Col>
                            <Col xs={5}>
                                <FormInput
                                    min={0}
                                    required
                                    type="number"
                                    append="%"
                                    name="price-level-new-sell-price"
                                    containerClass={"mb-2"}
                                    value={changeSellPriceByPercentage}
                                    onChange={(e) => setChangeSellPriceByPercentage(parseInt(e.target.value))}
                                />
                            </Col>
                        </Row>
                    </>
                    }
                    {changeSellPriceBy === 2 && <>
                        <Row className="ms-0">
                            <Col xs={5}>
                                <p className="popup-form-text-field">Change Sell Price By $</p>
                            </Col>
                            <Col xs={5}>
                                <FormInput
                                    min={0}
                                    required
                                    prepend="$"
                                    type="number"
                                    name="price-level-new-gp"
                                    containerClass={"mb-2"}
                                    value={changeSellPriceByAmount}
                                    onChange={(e) => setChangeSellPriceByAmount(parseInt(e.target.value))}
                                />
                            </Col>
                        </Row>
                    </>
                    }

                    {changeSellPriceBy === 3 && <>
                        <Row className="ms-0">
                            <Col xs={5}>
                                <p className="popup-form-text-field">Change Current GP% by</p>
                            </Col>
                            <Col xs={5}>
                                <FormInput
                                    min={0}
                                    required
                                    type="number"
                                    prepend="$"
                                    name="price-level-new-sell-price"
                                    containerClass={"mb-2"}
                                    value={changeCurrentGPby}
                                    onChange={(e) => setChangeCurrentGPby(parseInt(e.target.value))}
                                />
                            </Col>
                        </Row>
                    </>}

                </Row>
                <Modal.Footer>
                    <Button variant="secondary" className="cta-button"
                    // onClick={() => handleChange("stockPopup", false)}
                    >Cancel</Button>
                    <Button variant="primary" className="cta-button" onClick={saveSelectedStock}>Save</Button>
                </Modal.Footer>
            </Modal.Body>
        </Modal>
    );
}